




































































import { Vue, Component } from 'vue-property-decorator';

import SignUpService from '@/api/SingupService';
import APIService from '@/api';
import ManagerService from '@/api/ManagerService';

import { treatError } from '@/utils';
import { parseToBoolean } from '@/utils/parseToBoolean';
import refreshBusinessInformation from '@/utils/refresh-business-information';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import AccountForm, {
  AccountFormData
} from '@/componentsV2/templates/AccountForm/V2/AccountForm.vue';
import InviteMailBox from '@/componentsV2/molecules/InviteMailBox/InviteMailBox.vue';

export enum EYourAccountInvitationStepSlug {
  WELCOME = 'welcome',
  COMPLETE_SIGNUP = 'complete-signup'
}

@Component({
  components: {
    FilledButton,
    AccountForm,
    InviteMailBox
  }
})
export default class InvitationCreateAccountOwner extends Vue {
  signUpService = new SignUpService({ disableToastMessage: true });
  managerService = new ManagerService();

  loading = false;
  inviteData: Record<string, any> = {};

  activeStepSlug: string = EYourAccountInvitationStepSlug.WELCOME;

  get isWelcomeStep() {
    return this.activeStepSlug === EYourAccountInvitationStepSlug.WELCOME;
  }

  get title() {
    if (!this.isWelcomeStep) return "We're almost there";
    return `Welcome to your ${this.inviteData.businessName} portal`;
  }

  nextStep() {
    this.activeStepSlug = EYourAccountInvitationStepSlug.COMPLETE_SIGNUP;
  }

  created() {
    const query = this.$route.query;
    const queryParams = Object.assign({}, this.$route.query, {
      isManagerRegistered: parseToBoolean(query.isManagerRegistered),
      isInvitedManager: parseToBoolean(query.isInvitedManager)
    });

    this.inviteData = queryParams;
  }

  async handleAcceptInvite() {
    this.loading = true;

    const { data } = await this.managerService.checkInvite(
      this.inviteData.inviteCode
    );

    if (data.isInvitedManager) {
      const { status, data } = await this.managerService.acceptInvite(
        this.inviteData.inviteCode
      );

      if (status !== 200) return;

      const { access_token } = data;
      this.signUpService.setCredentials(access_token);
      await refreshBusinessInformation();
      window.location.href = '/';

      this.loading = false;

      return;
    }

    this.loading = false;

    APIService.resetCredentials(() => {
      window.location.assign(`/invite/${this.inviteData.inviteCode}`);
    });
  }

  async onSubmit(formData: AccountFormData) {
    this.loading = true;

    try {
      const { firstName, lastName, email, password } = formData;

      const manager = {
        fullname: `${firstName} ${lastName}`,
        mail: email,
        password
      };

      const { data } = await this.signUpService.createManager({ manager });

      this.signUpService.setCredentials(data.access_token);
      await this.handleAcceptInvite();
    } catch (err) {
      treatError(err);
    } finally {
      this.loading = false;
    }
  }
}
